// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const InterceptionTargetSchema = z.enum(['HEADER','COOKIE','JSON_BODY','QUERY_PARAM'] as const);

export type InterceptionTargetType = `${z.infer<typeof InterceptionTargetSchema>}`

export default InterceptionTargetSchema;
